/* storybook-check-ignore */
import { useCallback } from 'react';

import { Box, Button } from '@opendoor/bricks-next';

import { useTrackProperty } from 'components/marketplace/helpers';

import { useObservability } from '../../../helpers/observability';
import { CONSUMER_URL } from '../../globals';

export const SelfTourCTA = ({ addressToken }: { addressToken: string }) => {
  const { trackProperty } = useTrackProperty();
  const { trackJourneyEvent } = useObservability();

  const trackOnSelfTourClick = useCallback(() => {
    trackProperty('property-self-tour', 'marketplace-pdp');
    trackJourneyEvent('marketplaceProperty', 'tourBookingStart', {
      addressUuid: addressToken,
      placement: 'above-the-fold',
    });
  }, []);

  return (
    <Box flexDirection="row" justifyContent="space-between">
      <Button
        analyticsName="cosmos-marketplace-self-tour-cta"
        variant="secondary"
        size="small"
        mt={24}
        onPress={trackOnSelfTourClick}
        target="_blank"
        rel="noopener"
        label="Self-tour"
        width="48%"
        href={`${CONSUMER_URL}/dashboard/buy/tour?id=${addressToken}`}
      />
    </Box>
  );
};
